export default {
  Query: {
    fields: {
      topics: { merge: false },
    },
  },
};
